export default {
  active_orders: {
    title: 'Comenzi active',
  },
  order_history: {
    title: 'Istoric comenzi',
  },
  menu: {
    title: 'Meniu',
  },
  printer_settings: {
    title: 'Setări imprimantă',
  },
  order_control: {
    title: 'Control comenzi',
  },
  busy_mode: {
    title_zero: 'Mod ocupat',
    title_other: 'Mod ocupat (+{{time}} min)',
  },
  volume: {
    title: 'Volum',
  },
  switch_language: {
    title: 'Schimbați limba ({{language}})',
  },
  logout: {
    title: 'Deconectare',
    description: 'Sigur doriți să vă deconectați?',
    buttons: {
      confirm: 'Da',
      cancel: 'Anulează',
    },
  },
};
